const keycloakConfig = {
  KEYCLOAK_CLIENT_ID: process.env.VUE_APP_KEYCLOAK_CLIENT_ID || "",
  KEYCLOAK_REALM: process.env.VUE_APP_KEYCLOAK_REALM || "",
  KEYCLOAK_URL:
    process.env.VUE_APP_KEYCLOAK_URL ||
    process.env.VUE_APP_KEYCLOAK_BASE_URL ||
    "",
  KEYCLOAK_REDIRECT_URL:
    process.env.VUE_APP_KEYCLOAK_REDIRECT_URL ||
    process.env.VUE_APP_KEYCLOAK_REDIRECT_URI ||
    "",
};
export default keycloakConfig;

